import { ChangeDetectionStrategy, Component, effect, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SnackbarService } from '@comparit/core';
import { ApiAction } from '@comparit/shared';
import type { VorgangDocument } from '@comparit/common-api';
import { TarifdetailsBaseService } from '../../../services/tarifdetails-base.service';

/** One tariff document, downloaded through the Sparte's own endpoint behind the seam. */
@Component({
  selector: 'ui-dokument-download-button',
  templateUrl: './dokument-download-button.component.html',
  styleUrl: './dokument-download-button.component.scss',
  imports: [MatIconModule, MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DokumentDownloadButtonComponent {
  private readonly tarifdetails = inject(TarifdetailsBaseService);
  private readonly snackbar = inject(SnackbarService);

  readonly doc = input.required<VorgangDocument>();

  protected readonly download = new ApiAction();

  constructor() {
    effect(() => {
      const error = this.download.error();
      if (error) this.snackbar.error(error);
    });
  }

  protected onDownload(): void {
    this.download.execute(
      this.tarifdetails.downloadDokument$(this.doc()),
      () => 'Dokument konnte nicht heruntergeladen werden.'
    );
  }
}
